import { Component } from '@angular/core';

@Component({
  selector: 'app-jee-mains-session1-hlt-entry-link',
  templateUrl: './jee-mains-session1-hlt-entry-link.component.html',
  styleUrls: ['./jee-mains-session1-hlt-entry-link.component.scss']
})
export class JeeMainsSession1HltEntryLinkComponent {

}
